document.addEventListener('DOMContentLoaded', () => {
    const planSelectorFieldset = document.getElementById('paywhirl-plan-selector-0');

    if (!planSelectorFieldset) {
        console.log('Plan selector fieldset not found.');
        return;
    }

    let product;
    try {
        product = JSON.parse(planSelectorFieldset.dataset.product);
    } catch (e) {
        console.error('Unable to parse product data:', e);
        return;
    }

    const priceContainer = document.querySelector('.paywhirl-plan-selector-price');
    const paywhirlPriceEl = priceContainer ? priceContainer.querySelector('.paywhirl-price') : null;
    const stPriceEl = document.querySelector('.st-price .price');

    let lastKnownValue = "";

    const ensureDropdownInitialized = () => {
        const planContainer = planSelectorFieldset.querySelector('.paywhirl-plan-selector-plan');
        const dropdown = planContainer?.querySelector('select');
        const hiddenInput = planSelectorFieldset.querySelector('input[name="selling_plan"]');

        if (!dropdown || !hiddenInput) {
            console.log('Dropdown or hidden input not ready yet.');
            return;
        }

        if (dropdown.dataset.listenerAttached) {
            console.warn('Event listeners already attached.');
            return;
        }

        if (!dropdown.querySelector('option[value=""]')) {
            const oneTimeOption = document.createElement('option');
            oneTimeOption.value = "";
            oneTimeOption.textContent = "One-time Purchase";
            dropdown.insertBefore(oneTimeOption, dropdown.firstChild);
        }

        dropdown.value = "";
        hiddenInput.value = "";
        lastKnownValue = "";

        const defaultVariantId = Object.keys(product.variants_by_id)[0];

        const updatePrices = (sellingPlanId) => {
            const variantData = product.variants_by_id[defaultVariantId];
            const priceInfo = sellingPlanId 
                ? variantData.selling_plan_allocations_by_id[sellingPlanId] || null 
                : { price: variantData.price, price_formatted: variantData.price_formatted };

            if (priceInfo) {
                if (paywhirlPriceEl) paywhirlPriceEl.textContent = priceInfo.price_formatted;
                if (stPriceEl) stPriceEl.textContent = priceInfo.price_formatted;
            }
        };

        updatePrices("");

        dropdown.addEventListener('change', (event) => {
            const selectedValue = event.target.value || "";
            hiddenInput.value = selectedValue;
            lastKnownValue = selectedValue;
            updatePrices(selectedValue);
        });

        dropdown.dataset.listenerAttached = "true";

        const mutationHandler = (mutationList) => {
            mutationList.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'value' && hiddenInput.value !== lastKnownValue) {
                    hiddenInput.value = lastKnownValue;
                }
            });
        };

        const inputObserver = new MutationObserver(mutationHandler);
        inputObserver.observe(hiddenInput, { attributes: true });
    };

    const observer = new MutationObserver(() => {
        ensureDropdownInitialized();
    });

    observer.observe(planSelectorFieldset, { childList: true, subtree: true });

    ensureDropdownInitialized(); // Attempt immediate initialization
});
